module.exports = __webpack_public_path__ + "media/images/contact-pin-84bb505a5bfc73a843d6fe498bdb8869.png";